import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function currencyClass(amount: number) {
  const numeric = 'font-mono tabular-nums'
  if (amount > 0) return `${numeric} text-emerald-700`
  if (amount < 0) return `${numeric} text-rose-700`
  return `${numeric} text-muted-foreground`
}

export function formatCurrency(amount: number, currency = 'MXN') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amount)
}
